import type { StyleRule } from '@archipro-design/aria';
import { pxToRem } from '@archipro-design/aria';
import {
    DUO_COLUMN_WIDTH,
    ROW_GAP_MOBILE,
} from '@modules/page-builder/config/column-constants';

export const DuoImageModuleContainer: StyleRule = ({ theme }) => ({
    display: 'flex',
    flexFlow: 'column',

    [theme.screen.laptop]: {
        display: 'grid',
        gridTemplateColumns: 'repeat(2, 1fr)',
        columnGap: pxToRem(204),
        gridTemplateRows: `1fr`,
        maxWidth: pxToRem(DUO_COLUMN_WIDTH),
        margin: 'auto',
    },
});

export const DuoImageContainerImage: (isMedium: boolean) => StyleRule<{
    columns: number;
    mobile: boolean;
}> =
    (isMedium) =>
    ({ columns, mobile, theme }) => {
        if (isMedium && !mobile) {
            return { margin: '0 auto' };
        }

        if (mobile) {
            return Object.assign({
                margin: '0 auto',
                '&:last-child':
                    columns > 1
                        ? {
                              margin: `${pxToRem(ROW_GAP_MOBILE)} auto 0`,
                          }
                        : undefined,
            });
        }
        return {
            margin: `${pxToRem(ROW_GAP_MOBILE)} auto 0`,
            [theme.screen.laptop]: {
                margin: 'auto',
                '&:has(.isMedium)': {
                    margin: '0 auto',
                },
            },
        };
    };
